"use client";
import { cn } from "@/lib/utils";

export const defaultOpacities = [100, 80, 60, 40, 20, 10, 5];

export const defaultSizes = [1, 2, 4, 6, 8, 16, 20, 24, 32];

export const defaultPatterns = [
  "lines",
  "vertical-lines",
  "dots",
  "rhombus",
  "cross",
  "wavy",
  "zigzag",
  "zigzag-3d",
  "isometric",
  "boxes",
  "rectangles",
  "diagonal-lines",
  "triangles",
  "moon",
  "paper",
];

export function generatePattern(
  patternName: string,
  patternSize: string,
  patternColor: string,
  patternSecondaryColor: string,
  patternOpacity: string,
) {
  return (
    "pattern-" +
    patternName +
    " pattern-" +
    patternColor +
    " pattern-bg-" +
    patternSecondaryColor +
    " pattern-opacity-" +
    patternOpacity +
    " pattern-size-" +
    patternSize
  );
}

export const colors = [
  "slate",
  "gray",
  "zinc",
  "neutral",
  "stone",
  "red",
  "orange",
  "amber",
  "yellow",
  "lime",
  "green",
  "emerald",
  "teal",
  "cyan",
  "sky",
  "blue",
  "indigo",
  "violet",
  "purple",
  "fuchsia",
  "pink",
  "rose",
];

export function ThemePattern({
  patternName,
  patternSize,
  patternColor,
  patternSecondaryColor,
  patternOpacity,
  inSheet,
}: any) {
  return (
    <div
      className={cn(
        " flex fade-in top-0 min-h-screen h-screen w-full object-cover -z-50",
        inSheet ? "absolute" : "fixed",
        generatePattern(
          patternName,
          patternSize,
          patternColor,
          patternSecondaryColor,
          patternOpacity,
        ),
      )}
    ></div>
  );
}
